<template>
  <div>
    <el-select
      ref="input"
      :value="value"
      :disabled="disable"
      :multiple="multiple || false"
      v-model="nValue"
      placeholder="请选择"
      @change="change"
      :filterable="filterable || false"
      clearable
    >
      <el-option
        v-for="(item, key) in options"
        :key="key"
        :label="item.mc_name || item.mcName"
        :value="item[valueKey || 'mcId'] || item[valueKey || 'mc_id']"
        :valueKey="valueKey"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { getMapByid } from '../api/common';
import { mapState } from 'vuex';
export default {
  props: [
    'value',
    'id',
    'valueKey',
    'filterable',
    'formName',
    'disable',
    'multiple',
    'pid',
    'index',
    'curObj',
    'nowObj',
    'mcId',
    'mcName',
    'combineValue',
    'combineName',
    'combineId',
    'combineArray',
  ],
  computed: {
    ...mapState(['mapList']),
  },
  data() {
    return {
      nValue: this.value,
      options: [],
    };
  },
  created() {
    if (typeof this.id == 'object') {
      this.options = this.id;
    } else {
      if (this.$store.state.mapList[this.id]) {
        this.options = this.$store.state.mapList[this.id];
        this.nValue = this.value;
      } else {
        if (this.pid) {
          // alert(123456)
          //   alert(JSON.stringify(this.nowObj[this.pid]))

          if (this.nowObj[this.pid] == 240 || this.nowObj[this.pid] == 241) {
            this.getControlDevice(this.nowObj[this.pid]);
          }
          return;
        } else {
          getMapByid(this.id).then((res) => {
            this.options = res.data;
            this.$store.commit('addMapList', { key: this.id, value: res.data });
            this.nValue = this.value;
          });
        }
      }
    }
    if (this.formName == 'relayType' || this.formName == 'bindPort') {
      if (this.combineValue[this.combineName] != this.combineId) {
        this.options = [];
      }
    }
  },
  mounted() {},
  watch: {
    value() {
      this.nValue = this.value;
    },
    mapList() {
      // alert(123123);
    },
    curObj(v) {
      // console.log(v)
      // console.log(this.index)
      // console.log(this.pid)
      if (this.pid && this.index == v.index && this.pid == v.formName) {
        // 在这里调用联动的接口
        this.getControlDevice(this.nowObj[this.pid]);
      }
    },
    combineValue(v) {
      // console.log(v, this.combineName);
      if (this.formName != 'relayType' && this.formName != 'bindPort') {
        this.relayType = null;
        return;
      }

      if (v[this.combineName]) {
        // console.log(v[this.combineName], this.combineId, this.formName);
        if (v[this.combineName] != this.combineId) {
          this.options = [];
          return;
        }
        // let type = this.combineId == v[this.combineName];
        const options = this.formName == 'relayType' ? this.$store.state.mapList[this.id] : this.id;
        this.options = options.filter((item) => {
          return this.combineArray.indexOf(item.mc_id) != -1;
        });
        // console.log(this.options, '拿数据');
        return;
      }
      this.options = [];
    },
  },
  methods: {
    change(val) {
      this.$emit('update:value', val);
      this.$emit('changeValue', { actVal: this.id, index: this.index, val, formName: this.formName });
      // console.log(id )
    },
    getControlDevice(val) {
      this.$post('/crt/crtInfoByPointType', {
        companyNum: this.$route.query.id || '',
        pointType: val,
      }).then((res) => {
        this.$store.commit('addMapList', { key: val, value: res.data });

        this.options = res.data;
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
